import './site_common'

const openAnswer = () => {
  // セレクタ定義
  const ROOT_TARGET_SELECTOR = '.js-openAnswer-root-target'
  const CASSETTE_TARGET_SELECTOR = '.js-openAnswer-cassette-target'
  const TRIGGER_SELECTOR = '.js-openAnswer-trigger'

  // 開いた状態のクラス定義
  const OPEN_CLASS_NAME = 'is-open'

  const rootElements = document.querySelectorAll(ROOT_TARGET_SELECTOR)

  // 要素がない場合はここで処理終了
  if (rootElements.length) {
    rootElements.forEach((rootElement) => {
      const accordionItems = rootElement.querySelectorAll(CASSETTE_TARGET_SELECTOR)

      // さらに要素がない場合はここで処理終了
      if (accordionItems.length) {
        accordionItems.forEach((accordionItem) => {
          const accordionTrigger = accordionItem.querySelector(TRIGGER_SELECTOR)

          accordionTrigger.addEventListener('click', () => {
            accordionItem.classList.toggle(OPEN_CLASS_NAME)
          })
        })
      }
    })
  }
}

window.addEventListener('load', () => {
  // アコーディオンのためのクラス切り替え処理
  openAnswer()
})
